import * as React from 'react';
import styled from 'styled-components';
import Colours from './styled/Colours';
import Media from './styled/Media';

const Container = styled.div<{ isFlat: boolean; selectable: boolean }>`
  background-color: ${Colours.white};
  border-radius: 2px;

  ${({ isFlat }) =>
    isFlat
      ? `border: 1px solid ${Colours.lightGrey40}`
      : `box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);`}
  ${({ selectable }) =>
    selectable &&
    `
    transition: box-shadow 0.3s ease-in-out 0s;
    &:hover {
      box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 10px 0px;
      cursor: pointer;
    }
  `}
`;

export const CardBody = styled.div`
  padding: 1.5rem;
  position: relative;

  @media ${Media.mobile} {
    padding: 1rem;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${Colours.lightGrey20};
  padding: 1rem;
`;

type Props = {
  children: React.ReactNode;
  className?: string;
  selectable?: boolean;
  isFlat?: boolean;
  onClick?: () => void;
};

const Card = ({ children, className, selectable, isFlat, onClick }: Props) => (
  <Container
    selectable={selectable!}
    isFlat={isFlat!}
    className={className}
    onClick={onClick}
  >
    {children}
  </Container>
);
Card.defaultProps = {
  className: '',
  selectable: false,
  isFlat: false,
  onClick: undefined,
};

export default Card;
